import { useState } from 'react';
import { motion } from 'framer-motion';
import { useLanguage } from '../contexts/LanguageContext';

export const ProcesoEvolucion = () => {
  const { t } = useLanguage();
  const [sliderPosition, setSliderPosition] = useState(50);

  return (
    <section id="evolucion" className="py-20 lg:py-32 bg-[#0B0B0B]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2
            className="text-4xl sm:text-5xl lg:text-6xl font-light text-[#F5F5F5] tracking-tight mb-4"
            style={{ fontFamily: 'Playfair Display, serif' }}
            data-testid="evolucion-title"
          >
            {t.evolucion.title}
          </h2>
          <p className="text-base sm:text-lg text-[#9CA3AF] max-w-2xl mx-auto">
            {t.evolucion.subtitle}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          viewport={{ once: true }}
          className="max-w-3xl mx-auto"
        >
          <div
            className="relative aspect-[3/4] w-full select-none overflow-hidden rounded-2xl border border-white/10 bg-[#1C1C1C] shadow-2xl shadow-black/30 focus-within:ring-2 focus-within:ring-inset focus-within:ring-[#c5a880]"
            data-testid="comparison-slider"
          >
            <div className="absolute inset-0">
              <img
                src="/imagenes/tatuajes/casio-recien-hecho.jpg"
                alt="Tatuaje de Casio recién hecho"
                className="h-full w-full object-cover"
              />
              <div className="absolute right-4 top-4 rounded-full border border-white/10 bg-[#0B0B0B]/80 px-4 py-2 backdrop-blur-sm sm:right-6 sm:top-6">
                <span className="text-[#F5F5F5] text-sm tracking-wide font-medium">
                  {t.evolucion.fresh}
                </span>
              </div>
            </div>

            <div
              className="absolute inset-0"
              style={{
                clipPath: `inset(0 ${100 - sliderPosition}% 0 0)`
              }}
            >
              <img
                src="/imagenes/tatuajes/casio-cicatrizado.jpg"
                alt="El tatuaje de Casio después de cicatrizar"
                className="h-full w-full object-cover"
              />
              <div className="absolute left-4 top-4 rounded-full border border-white/10 bg-[#0B0B0B]/80 px-4 py-2 backdrop-blur-sm sm:left-6 sm:top-6">
                <span className="text-[#F5F5F5] text-sm tracking-wide font-medium">
                  {t.evolucion.healed}
                </span>
              </div>
            </div>

            <input
              aria-label={t.evolucion.sliderLabel}
              aria-valuetext={`${t.evolucion.healed}: ${sliderPosition}%, ${t.evolucion.fresh}: ${100 - sliderPosition}%`}
              className="absolute inset-0 z-20 m-0 h-full w-full cursor-ew-resize appearance-none opacity-0"
              max="100"
              min="0"
              onChange={(event) => setSliderPosition(Number(event.target.value))}
              type="range"
              value={sliderPosition}
            />

            <div
              className="absolute top-0 bottom-0 w-1 bg-[#E5E5E5] z-10"
              style={{ left: `${sliderPosition}%` }}
            >
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-12 h-12 bg-[#E5E5E5] rounded-full flex items-center justify-center shadow-lg">
                <div className="flex gap-1">
                  <div className="w-0.5 h-4 bg-[#0B0B0B]" />
                  <div className="w-0.5 h-4 bg-[#0B0B0B]" />
                </div>
              </div>
            </div>
          </div>

          <p className="mt-5 text-center text-sm text-[#9CA3AF]">
            {t.evolucion.instruction}
          </p>
        </motion.div>
      </div>
    </section>
  );
};
